  import  { useEffect } from "react";
  import "./Balls.css";

  const FloatingBalls = () => {
    useEffect(() => {
      const colors = ["#3CC157", "#2AA7FF", "#1B1B1B", "#FCBC0F", "#F85F36"];
      const numBalls = 20;
      const balls = [];

      for (let i = 0; i < numBalls; i++) {
        const ball = document.createElement("div");
        ball.classList.add("ball");
        ball.style.background = colors[Math.floor(Math.random() * colors.length)];
        ball.style.left = `${Math.floor(Math.random() * 90)}vw`;
        ball.style.top = `${Math.floor(Math.random() * 90)}vh`;
        ball.style.transform = `scale(${Math.random()})`;
        ball.style.width = `${Math.random()}em`;
        ball.style.height = ball.style.width;

        balls.push(ball);
        document.body.append(ball);
      }

      balls.forEach((el, i) => {
        const to = {
          x: Math.random() * (i % 2 === 0 ? -11 : 11),
          y: Math.random() * 12,
        };

        el.animate(
          [
            { transform: "translate(0, 0)" },
            { transform: `translate(${to.x}vw, ${to.y}vh)` },
          ],
          {
            duration: (Math.random() + 1) * 2000,
            direction: "alternate",
            fill: "both",
            iterations: Infinity,
            easing: "ease-in-out",
          }
        );
      });

      // Cleanup on unmount
      return () => {
        balls.forEach((ball) => {
          document.body.removeChild(ball);
        });
      };
    }, []);

    return null; // No JSX needed, as we're creating elements dynamically
  };

  export default FloatingBalls;
